export default "__VITE_ASSET__Dn_Flyt7__"